export default class Divers {
  constructor(element) {
    this.element = element;
    this.init();
  }


  init() {
      
      this.setLoader();
      this.setMask();
      
    }
    
    setLoader(){
        window.addEventListener("DOMContentLoaded", () => {
            const loader = document.getElementById("loader");
            const content = document.getElementById("content");
            
            // Check if the loader has already been shown
            const hasVisited = sessionStorage.getItem("visited");
            
            if (hasVisited) {
                // Skip animation
                loader.style.display = "none";
                content.style.display = "block";
            } else {
                // Play animation once
                sessionStorage.setItem("visited", "true");
                
                // Example fake animation delay
                setTimeout(() => {
                    loader.style.display = "none";
                    content.style.display = "block";
                }, 3000); // Adjust delay to match your animation
            }
        });
    }
    
    setMask(){
        this.mask = document.querySelector('.masque');
        this.maskedContent = this.element.querySelector('.masque_content');


        if(this.mask){
            window.addEventListener('mousemove', (e) => {
                let x = (e.clientX / window.innerWidth) * 100;
                let y = (e.clientY / window.innerHeight) * 100;
    
                x = x / 4 + 50;
                y = y / 3 + 40;
                
                this.maskedContent.style.setProperty('--mask-x', `${x}%`);
                this.maskedContent.style.setProperty('--mask-y', `${y}%`);
            });
        }
    }
}
